// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/config/angularProductionConfig.js#1 $
'use strict';
angular.module('tcApp')
.config(function($compileProvider, $windowProvider) {
	var $window = $windowProvider.$get();
	// Disable debug information, if not opened via system.HomeDebug.cls
	if ($window.location.pathname.indexOf('Debug.cls') == -1) {
		$compileProvider.debugInfoEnabled(false);
	}
	// Disable class and comment directives
	$compileProvider.commentDirectivesEnabled(false);
	$compileProvider.cssClassDirectivesEnabled(false);
});
